let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4JCpI")).then(() => parcelRequire('eZ9Cp'));